module.exports = __webpack_public_path__ + "static/img/Vivendi-Create-Joy.33273e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/Vivendi-Create-Joy.svg
// module id = 545
// module chunks = 2